import { ListAlt } from '@mui/icons-material'
import MusicSectionCreate from './MusicSectionCreate'
import MusicSectionEdit from './MusicSectionEdit'
import MusicSectionList from './MusicSectionList'

const musicSectionIndex = {
  icon: ListAlt,
  list: MusicSectionList,
  edit: MusicSectionEdit,
  create: MusicSectionCreate,
}

export default musicSectionIndex
